import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import element from 'element-plus'
import 'element-plus/dist/index.css'
const app = createApp(App,{
    productionTip: true
})
app.use(store).use(router).use(element).mount('#app')
